import { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Layout as TLayout, Menu, Avatar } from 'tdesign-react';
import { UserListIcon, FileIcon, UserIcon, ChatIcon } from 'tdesign-icons-react';
import type { MenuValue } from 'tdesign-react';
import { useAdminUser } from '@/pages/portal/AdminGuard';
import './Layout.css';

const { Header, Content, Aside } = TLayout;
const { MenuItem } = Menu;

interface MenuLeaf {
  value: string;
  label: string;
  icon: JSX.Element;
}

// 菜单数据使用结构化常量，禁止在 JSX 内做嵌套三元判断
const menuItems: MenuLeaf[] = [
  { value: 'commands', label: '指令记录', icon: <FileIcon /> },
  { value: 'accounts', label: '账号管理', icon: <UserListIcon /> },
  { value: 'wecom-chats', label: '群聊管理', icon: <ChatIcon /> },
];

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname.split('/')[1] || 'commands';

  // 用户信息由 AdminGuard 在路由进入前已探测好，直接从 context 取，避免 Layout 重复请求 /user/me
  const user = useAdminUser();
  const [avatarBroken, setAvatarBroken] = useState(false);

  const handleMenuClick = (value: MenuValue) => {
    navigate(`/${value}`);
  };

  return (
    <TLayout className="layout-container">
      <Header className="layout-header">
        <div className="header-content">
          <h1>指令提交系统</h1>
        </div>
        <div className="header-user">
          {user ? (
            <>
              <Avatar
                size="32px"
                image={avatarBroken ? undefined : user.avatar}
                icon={<UserIcon />}
                onError={() => setAvatarBroken(true)}
              />
              <span className="header-username">{user.displayName}</span>
            </>
          ) : null}
        </div>
      </Header>
      <TLayout>
        <Aside className="layout-aside">
          <Menu value={currentPath} onChange={handleMenuClick} theme="light">
            {menuItems.map((item) => (
              <MenuItem key={item.value} value={item.value} icon={item.icon}>
                {item.label}
              </MenuItem>
            ))}
          </Menu>
        </Aside>
        <Content className="layout-content">
          <div className="content-wrapper">
            <Outlet />
          </div>
        </Content>
      </TLayout>
    </TLayout>
  );
};

export default Layout;
